import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {ChartsComponent} from "./charts.component";
import {RouterModule} from "@angular/router";
import {
  DxBoxModule, DxButtonModule, DxListModule, DxPopupModule, DxRadioGroupModule, DxResponsiveBoxModule, DxTabPanelModule,
  DxTreeListModule,
  DxTreeViewModule
} from "devextreme-angular";
import { HighchartsChartModule } from 'highcharts-angular';
import {DeviceDetectorModule} from "ngx-device-detector";
import {DxoPagingModule} from "devextreme-angular/ui/nested/paging";
import {DxoPagerModule} from "devextreme-angular/ui/nested/pager";


@NgModule({
  imports: [
    CommonModule, RouterModule,
    DxTabPanelModule,
    DxBoxModule,
    DxPopupModule,
    DxTreeListModule,
    DxListModule,
    DxButtonModule,
    DxResponsiveBoxModule,
    HighchartsChartModule,
    DxRadioGroupModule,
    DeviceDetectorModule.forRoot(),
    DxoPagingModule,
    DxoPagerModule

  ],
  declarations: [ChartsComponent],
  exports: [ChartsComponent]
})
export class ChartsModule { }



// WEBPACK FOOTER //
// ./src/app/components/charts/charts.module.ts